<script setup lang="ts">
import type { ChangelogCursorPaginationProps } from '@entities/changelog'

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTableSelect } from '@shared/ui/selects'
import { AppIcon } from '@shared/ui/icons'

import { useChangelogCursorPagination } from '../model/changelog-cursor-pagination.hook'

defineOptions({
  name: 'ChangelogCursorPagination',
})

const props = withDefaults(defineProps<ChangelogCursorPaginationProps>(), {
  disabled: false,
  showTitle: true,
})

const emit = defineEmits<{
  'change:per-page': [value: number]
  prev: []
  next: []
}>()

const {
  perPageOptions,
  title,
  isPrevDisabled,
  isNextDisabled,
  handlePrev,
  handleNext,
  handlePerPageChange,
} = useChangelogCursorPagination({
  props,
  onPrev: () => emit('prev'),
  onNext: () => emit('next'),
  onPerPageChange: (value) => emit('change:per-page', value),
})
</script>

<template>
  <div class="changelog-pagination">
    <div class="changelog-pagination__general">
      <AppText
        name="body2"
        color="slate-700"
      >
        Rows per page:
      </AppText>
      <AppTableSelect
        :model-value="perPage"
        :options="perPageOptions"
        :disabled="disabled"
        @update:model-value="handlePerPageChange"
      />
    </div>
    <AppText
      v-if="showTitle"
      class="changelog-pagination__title"
      name="body2"
      color="slate-700"
    >
      {{ title }}
    </AppText>
    <nav class="changelog-pagination__nav">
      <button
        type="button"
        class="changelog-pagination__link"
        :disabled="isPrevDisabled"
        @click="handlePrev"
      >
        <AppIcon
          :icon="faChevronLeft"
          size="small"
        />
      </button>
      <button
        type="button"
        class="changelog-pagination__link"
        :disabled="isNextDisabled"
        @click="handleNext"
      >
        <AppIcon
          :icon="faChevronRight"
          size="small"
        />
      </button>
    </nav>
  </div>
</template>

<style scoped lang="scss" src="./ChangelogCursorPagination.scss" />
